export default "/_next/static/media/lobby-header.a9533b3a3cf104f782446b57a2e5f560.mp4";